import React from "react";
import { LinkButton } from "./TableLink.styles";
import type { TableLinkProps } from "./TableLink.types";

export const TableLink: React.FC<TableLinkProps> = ({
  children,
  onClick,
  disabled,
  className,
}) => (
  <LinkButton
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={className}
  >
    {children}
  </LinkButton>
);

export default TableLink;
